export enum PerformanceAnalysisJobFilter {
  ALL_JOBS = 'all-jobs',
  ALL_OPEN_JOBS = 'all-open-jobs',
  ALL_BASIC_JOBS = 'all-basic-jobs',
  ALL_AGENTS_JOBS = 'all-agents-jobs',
}
